import React, { useState, useEffect, useContext } from 'react';
import OnceFooter from "./../common/Footer/OnceFooter";
import Menu from "./../common/Menu/Menu";
import Services from "./../HomeSection/Services";
import SliderHome from "./../HomeSection/SliderHome";
import TopCtaArea from "./../HomeSection/TopCtaArea";
import { useParams } from 'react-router-dom';
import api from './../../utils/api';
import { AppContext } from "./../context/ContextProvider";
import { Modal, Button, Row, Col, Form, Collapse, Card, Nav, Tab } from 'react-bootstrap';
import { numberFormat, inputKeyPressOnlyNumber } from './../../utils/functions';
import { toast } from 'react-toastify';
import moment from "moment";
import 'moment/locale/th'
import _ from "lodash";
import ReactGA from 'react-ga4';

export default function BookingCartStatus() {
  const { id, code } = useParams();
  const [cart, setCart] = useState({});
  const { hotel, bookings } = cart;
  const [showCollapse, setShowCollapse] = useState([]);

  const booking = bookings && bookings.length > 0 ? bookings[0] : null;

  const endDate = new Date(booking?.end_date)
  const endDateStr = endDate.setDate(endDate.getDate() + 1)

  const [policies, setPolicies] = useState([]);
  const [foods, setFoods] = useState([]);
  const [attractions, setAttractions] = useState([]);

  const fetchPolicies = (_hotel_id, _room_ids = []) => {
    if (!_hotel_id) return;

    let params = {
      hotel_id: _hotel_id,
      enabled: true,
      types: ['hotel_policy']
    }

    if (_room_ids && _room_ids.length > 0) {
      params.types.push('room_policy')
      params.with_room_ids = _room_ids
    }

    api.request(`hotels/hotel-info/all`, (data) => {
      if (!data || data.length === 0) {
        setPolicies([]);
        return;
      }

      setPolicies(data);
    }, params)
  }

  const fetchRecommentPlaces = (_hotel_id) => {
    if (!_hotel_id) return;

    api.request(`hotels/recommend-nearby-places/all`, (data) => {
      if (!data || data.length === 0) {
        setFoods([]);
        setAttractions([]);
        return;
      }

      const foodsData = data.filter((d) => d.type === 'food') || [];
      const attractionsData = data.filter((d) => d.type === 'attraction') || [];

      setFoods(foodsData);
      setAttractions(attractionsData);
    }, {
      hotel_id: _hotel_id,
      enabled: true,
    })
  }

  const fetchBookingData = () => {
    api.request(`bookings/findonebookingcart`, (data) => {
      setCart(data || {})
      setShowCollapse(Array(data?.bookings?.length).fill(true));

      if (data?.hotel?.show_hotel_info_to_customer) {
        fetchRecommentPlaces(data?.hotel_id);
        fetchPolicies(data?.hotel_id, (data?.bookings || [])?.map((b) => b.room_id) || []);
      }
    }, {
      id: id,
      transaction_no: code,
    })
  }

  useEffect(() => {
    if (!!id) {
      fetchBookingData()
    }
  }, [id])

  const warningMsg = `ขณะนี้ระบบ "Once In Memory" ${booking?.payment_state === 'complete' ? 'ได้จัดส่งใบเสร็จรับเงิน' : 'ได้รับข้อมูลการจองห้องพักจากท่านแล้ว โดยเราได้ส่งรายละเอียดถึงท่าน'}ผ่านทาง SMS และอีเมล กรุณาตรวจสอบข้อมูลด้วยนะคะ`

  const hotelPolicy = policies.find((p) => p.type === 'hotel_policy') || null;
  const roomPolicies = policies.filter((p) => p.type === 'room_policy') || [];

  const [placeHtmlDataForShow, setPlaceHtmlDataForShow] = useState(null);
  const _doc = cart?.bookings && cart?.bookings.length > 0 ? cart?.bookings[0]?.receipt_file_path : null;

  const bookingOverviewSection = () => {
    return (
      <Row>
        {!!_doc && <Col xs={12} className="mb-3">
          <Button variant="success" size="sm" onClick={() => {
            window.open(_doc, '_blank')
          }}>ดาวน์โหลดใบสรุปรายการจอง</Button>
        </Col>}
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12}>
              <span className="title">หมายเลขการทำรายการ : </span>
              <span className="detail">{cart.transaction_no}</span>
            </Col>
            <Col xs={12}>
              <span className="title">วันที่เข้าพัก : </span>
              <span className="detail">{moment(booking?.start_date).format('DD/MM/YYYY')} - {moment(endDateStr).format('DD/MM/YYYY')} ({booking?.day_qty} คืน)</span>
            </Col>
            <Col xs={12}>
              <span className="title">ชื่อผู้ติดต่อ : </span>
              <span className="detail">{booking.contact_name}</span>
            </Col>
            {!!hotel && hotel.request_customer_tax_info_enabled && <Col xs={12}>
              <span className="title">เลขประจำตัวผู้เสียภาษี : </span>
              <span className="detail">{booking.customer_tax_id}</span>
            </Col>}
            {!!hotel && hotel.request_customer_tax_info_enabled && <Col xs={12}>
              <span className="title">ที่อยู่ในการออกใบเสร็จรับเงิน : </span>
              <span className="detail">{booking.customer_address || '-'}</span>
            </Col>}
            <Col xs={12}>
              <span className="title">หมายเลขโทรศัพท์ : </span>
              <span className="detail">{booking.contact_tel_1} {!!booking.contact_tel_2 ? `/ ${booking.contact_tel_2}` : ''}</span>
            </Col>
            <Col xs={12}>
              <span className="title">อีเมล : </span>
              <span className="detail">{booking.contact_email || '-'}</span>
            </Col>
            <Col xs={12}>
              <span className="title">ไลน์ไอดี (Line ID) : </span>
              <span className="detail">{booking.contact_line_id || '-'}</span>
            </Col>
            <Col xs={12}>
              <span className="title">ยี่ห้อรถ : </span>
              <span className="detail">{booking.customer_car_model || '-'}</span>
            </Col>
            <Col xs={12}>
              <span className="title">ทะเบียนรถ : </span>
              <span className="detail">{booking.customer_car_license_plate || '-'}</span>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={6}>
          {bookings && bookings.length > 0 && bookings.map((b, bIndex) => {
            const addons = b.booking_addons || [];
            const addonsText = (b.booking_addons || []).map((x) => { return `${x?.addons_type?.name_th} (${x?.qty})` })
            const addonsTextStr = (addonsText || []).join(', ')
            const addonsSum = _.sumBy(b.booking_addons || [], (x) => { return Number(x.total_price || 0) }) || 0

            const outstanding = b.payment_type === 'full' ? 0 : (Number(b.net_total || 0) - Number(b.paid_amount || 0))
            const roomDeposit = !!b.room_deposits && b.room_deposits.length > 0 ? b.room_deposits[0] : null

            const additionalPrice = Number(b.additional_guest_total_price || 0)
            const addtiionalPet = b.booking_additional_pets && b.booking_additional_pets.length > 0 ? b.booking_additional_pets[0] : null;

            return (
              <Card key={bIndex} className="mb-3">
                <Card.Header aria-controls={`collapse_booking_${bIndex}`} aria-expanded={showCollapse[bIndex]} onClick={() => {
                  let newShowCollapse = [...showCollapse];
                  newShowCollapse[bIndex] = !newShowCollapse[bIndex];
                  setShowCollapse(newShowCollapse);
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">{b.booking_no} : {b.room?.name_th}</h5>
                    <span className="toggle-collapse"><i className={`fas fa-chevron-${showCollapse[bIndex] ? 'up' : 'down'}`}></i> {showCollapse[bIndex] ? 'ซ่อนรายละเอียด' : 'แสดงรายละเอียด'}</span>
                  </div>
                </Card.Header>
                <Collapse in={showCollapse[bIndex]}>
                  <Card.Body id={`collapse_booking_${bIndex}`}>
                    <Row>
                      <Col xs={12}>
                        <span className="title">หมายเลขการจอง : </span>
                        <span className="detail">{b.booking_no}</span>
                      </Col>
                      <Col xs={12}>
                        <span className="title">ห้องพัก : </span>
                        <span className="detail">{b.room?.name_th}</span>
                      </Col>
                      <Col xs={12}>
                        <span className="title">ผู้เข้าพัก : </span>
                        <span className="detail">ผู้ใหญ่ {numberFormat(b.guest_qty, true)} ท่าน, เด็กไม่เกิน {hotel?.custom_guest_baby_age || 6} ปี {numberFormat(b.guest_baby_qty, true)} ท่าน</span>
                      </Col>
                      {additionalPrice > 0 && <Col xs={12}>
                        <span className="title">ผู้เข้าพัก (เสริม) : </span>
                        <span className="detail text-danger">ผู้ใหญ่ {numberFormat(b.additional_guest_qty, true)} ท่าน, เด็กไม่เกิน {hotel?.custom_guest_baby_age || 6} ปี {numberFormat(b.additional_baby_qty, true)} ท่าน</span>
                      </Col>}
                      {addtiionalPet && <Col xs={12}>
                        <span className="title">สัตว์เลี้ยง (เสริม) : </span>
                        <span className="detail text-danger">{addtiionalPet.pet_type?.name_th} จำนวน {numberFormat(addtiionalPet.qty, true)} ตัว</span>
                      </Col>}
                      <Col xs={12}>
                        <span className="title">ประเภทการชำระเงิน : </span>
                        {b.payment_type === 'payonstay' && <span className="badge bg-danger">ชำระวันเข้าพัก</span>}
                        {b.payment_type === 'deposit' && <span className="badge bg-danger">มัดจำ</span>}
                        {b.payment_type === 'full' && <span className="badge bg-success">ชำระเต็มจำนวน</span>}
                        {(!!roomDeposit || b.room_deposit_outstanding > 0) && <span className="badge bg-secondary ms-1">มีค่าประกัน</span>}
                      </Col>
                      {!!roomDeposit && <Col xs={12}>
                        <span className="title">ค่าประกันที่พัก : </span>
                        <span className="detail text-success">{numberFormat(roomDeposit.deposit_amount)} บาท (ชำระแล้ว)</span>
                      </Col>}
                      {b.room_deposit_outstanding > 0 && <Col xs={12}>
                        <span className="title">ค่าประกันที่พัก : </span>
                        <span className="detail text-danger">{numberFormat(b.room_deposit_outstanding)} บาท (กรุณาชำระวันเข้าพัก)</span>
                      </Col>}
                      <Col xs={12}>
                        <span className="title">ราคาที่พัก : </span>
                        <span className="detail">{numberFormat(b.total_price)} บาท</span>
                      </Col>
                      {additionalPrice > 0 && <Col xs={12}>
                        <span className="title">ราคาเสริมผู้เข้าพัก : </span>
                        <span className="detail">{numberFormat(additionalPrice)} บาท</span>
                      </Col>}
                      {addtiionalPet && <Col xs={12}>
                        <span className="title">ราคาเสริมสัตว์เลี้ยง : </span>
                        <span className="detail">{numberFormat(addtiionalPet.total_price)} บาท</span>
                      </Col>}
                      {addonsSum > 0 && <Col xs={12}>
                        <span className="title">ราคาอุปกรณ์เสริม : </span>
                        <span className="detail">{numberFormat(addonsSum)} บาท</span>
                      </Col>}
                      <Col xs={12}>
                        <span className="title">ส่วนลด : </span>
                        <span className="detail">{numberFormat(b.total_discount)} บาท</span>
                      </Col>

                      <Col xs={12}>
                        <span className="title">ค่าที่พักชำระแล้ว : </span>
                        <span className="detail text-success">{numberFormat(b.paid_amount)} บาท</span>
                      </Col>
                      <Col xs={12}>
                        <span className="title">ค่าที่พักค้างชำระ : </span>
                        <span className={`detail ${outstanding > 0 ? 'text-danger' : ''}`}>{numberFormat(outstanding)} บาท {outstanding > 0 && <small className="text-warning"> *กรุณาชำระเงินส่วนที่เหลือในวันเข้าพัก</small>}</span>
                      </Col>
                      {!!roomDeposit && <Col xs={12}>
                        <span className="title">ยอดชำระสุทธิ : </span>
                        <span className="badge bg-success">{numberFormat(Number(b.paid_amount || 0) + Number(roomDeposit.deposit_amount || 0))} บาท</span>
                      </Col>}
                      {booking.room_deposit_outstanding > 0 && <Col xs={12}>
                        <span className="title">ยอดชำระวันเข้าพัก : </span>
                        <span className="badge bg-danger">{numberFormat(Number(outstanding || 0) + Number(b.room_deposit_outstanding || 0))} บาท</span>
                      </Col>}
                      <Col xs={12}>
                        <span className="title">สถานะการชำระเงิน : </span>
                        {b.payment_state === 'waiting' && <span className="badge bg-warning">รอการตรวจสอบ</span>}
                        {b.payment_state === 'waiting-approved' && <span className="badge bg-danger">ชำระเงินวันเข้าพัก</span>}
                        {b.payment_state === 'complete' && <span className="badge bg-success">ชำระเงินเรียบร้อยแล้ว</span>}
                        {b.payment_state === 'partial' && <span className="badge bg-info">ชำระเงินมัดจำเรียบร้อยแล้ว</span>}
                      </Col>
                      <Col xs={12}>
                        <div>
                          <span className="title">หมายเหตุ : </span>
                          <span className="detail">{b.booking_note || '-'}</span>
                        </div>
                        {(addons && addons.length > 0) && <div>
                          <span className="title">อุปกรณ์เสริม : </span>
                          <span className="detail">{addonsTextStr || '-'}  ราคารวม {numberFormat(addonsSum)} บาท</span>
                        </div>}
                      </Col>
                    </Row>
                  </Card.Body>
                </Collapse>
              </Card>
            )
          })}
        </Col>
      </Row>
    )
  };

  const bookingOverviewTabs = () => {
    return (
      <Tab.Container defaultActiveKey="overview">
        <Nav variant="tabs" defaultActiveKey="overview" className="mb-3">
          <Nav.Item>
            <Nav.Link eventKey="overview">รายละเอียดการจอง</Nav.Link>
          </Nav.Item>
          {!!hotelPolicy && <Nav.Item>
            <Nav.Link eventKey="terms">{hotelPolicy.title_th || 'นโยบายการเข้าพัก'}</Nav.Link>
          </Nav.Item>}
          {roomPolicies.map((rp, rpIndex) => (
            <Nav.Item key={`room_policy_nav_${rpIndex}`}>
              <Nav.Link eventKey={`room_terms_${rpIndex}`}>{rp.title_th || 'นโยบายห้องพัก'}</Nav.Link>
            </Nav.Item>
          ))}
          {foods.length > 0 && <Nav.Item>
            <Nav.Link eventKey="foods">แนะนำร้านอาหาร</Nav.Link>
          </Nav.Item>}
          {attractions.length > 0 && <Nav.Item>
            <Nav.Link eventKey="attractions">แนะนำสถานที่ท่องเที่ยว</Nav.Link>
          </Nav.Item>}
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="overview">
            {bookingOverviewSection()}
          </Tab.Pane>
          {!!hotelPolicy && <Tab.Pane eventKey="terms" className="booking-policy">
            <div className="booking-term-condition" dangerouslySetInnerHTML={{ __html: hotelPolicy.detail_th }} />
          </Tab.Pane>}
          {roomPolicies.map((rp, rpIndex) => (
            <Tab.Pane key={`room_policy_pane_${rpIndex}`} eventKey={`room_terms_${rpIndex}`} className="booking-policy">
              <div className="booking-term-condition" dangerouslySetInnerHTML={{ __html: rp.detail_th }} />
            </Tab.Pane>
          ))}
          {foods.length > 0 && <Tab.Pane eventKey="foods">
            <Row>
              {foods.map((item, _i) => (
                <Col key={item.id} xs={12} lg={6} xl={4}>
                  <div className="d-block d-sm-flex align-items-center mt-2">
                    {!!item.image_url && <img className="rounded" style={{ width: 150 }} src={item.image_url} alt="" />}
                    {!item.image_url && <div className="text-center p-2 border rounded">
                      <i className="fal fa-images text-muted" style={{ fontSize: 20 }}></i>
                      <div><small className=" text-muted">No Image</small></div>
                    </div>}
                    <div className="ms-0 ms-sm-3 mt-2 mb-3 my-md-0">
                      <h5 className="m-0">{item.name_th}</h5>
                      {!!item.description_th && <div className="mb-0">{item.description_th}</div>}
                      {!!item.tel && <div className="mt-1 text-black">
                        <a href={`tel:${item.tel}`}>
                          <i className="fas fa-phone-alt"></i> {item.tel}
                        </a>
                      </div>}
                      {!!item.line_url && <div className="mt-1 text-success">
                        <a href={item.line_url} target="_blank" rel="noreferrer">
                          <i className="fab fa-line"></i> ติดต่อทางไลน์
                        </a>
                      </div>}
                      {!!item.google_map_url && <div className="mt-1 text-primary">
                        <a href={item.google_map_url} target="_blank" rel="noreferrer">
                          <i className="fas fa-map-marker-alt"></i> ดูแผนที่
                        </a>
                      </div>}
                      {!!item.place_link && <div className="mt-1 text-secondary">
                        <a href={item.place_link} target="_blank" rel="noreferrer">
                          <i className="fas fa-globe"></i> เว็บไซต์
                        </a>
                      </div>}
                      {!!item.detail_th && <div className="mt-1 text-secondary">
                        <Button variant="secondary" className="btn-sm mt-0" onClick={() => {
                          setPlaceHtmlDataForShow(item.detail_th)
                        }}>ดูข้อมูลเพิ่มเติม</Button>
                      </div>}
                      <hr className="d-block d-sm-none" style={{ color: 'darkgray' }} />
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Tab.Pane>}
          {attractions.length > 0 && <Tab.Pane eventKey="attractions">
            <Row>
              {attractions.map((item, _i) => (
                <Col key={item.id} xs={12} lg={6} xl={4}>
                  <div className="d-block d-sm-flex align-items-center mt-2">
                    {!!item.image_url && <img className="rounded" style={{ width: 80 }} src={item.image_url} alt="" />}
                    {!item.image_url && <div className="text-center p-2 border rounded">
                      <i className="fal fa-images text-muted" style={{ fontSize: 20 }}></i>
                      <div><small className=" text-muted">No Image</small></div>
                    </div>}
                    <div className="ms-0 ms-sm-3 mt-2 mb-3 my-md-0">
                      <h5 className="m-0">{item.name_th}</h5>
                      {!!item.description_th && <div className="mb-0">{item.description_th}</div>}
                      {!!item.tel && <div className="mt-1 text-black">
                        <a href={`tel:${item.tel}`}>
                          <i className="fas fa-phone-alt"></i> {item.tel}
                        </a>
                      </div>}
                      {!!item.google_map_url && <div className="mt-1 text-success">
                        <a href={item.google_map_url} target="_blank" rel="noreferrer">
                          <i className="fas fa-map-marker-alt"></i> ดูแผนที่
                        </a>
                      </div>}
                      {!!item.place_link && <div className="mt-1 text-secondary">
                        <a href={item.place_link} target="_blank" rel="noreferrer">
                          <i className="fas fa-info-circle"></i> รายละเอียดเพิ่มเติม
                        </a>
                      </div>}
                      <hr className="d-block d-sm-none" style={{ color: 'darkgray' }} />
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Tab.Pane>}
        </Tab.Content>
      </Tab.Container>
    )
  }

  return (
    <>
      <div className="text-center">
        {!cart?.id && <div className="p-5">
          <h4>ไม่พบข้อมูลการจองที่ค้นหา !</h4>
          <div>{'กรุณาตรวจสอบลิงค์ให้ถูกต้อง หรือติดต่อผู้ดูแลระบบ'}</div>
        </div>}

        {!!cart?.id && <div className="p-5 booking-status">
          <p className="text-success text-start text-md-center">{warningMsg}</p>
          <h4>รายละเอียดการจองห้องพัก</h4>
          <div className="text-start px-2 px-md-5 py-3">
            <div className="d-flex align-items-center">
              {!!hotel?.logo_file_path && <img src={hotel?.logo_file_path} className="hotel-logo" alt="img" />}
              <h5 className="mx-2">{hotel?.name_th}</h5>
            </div>
            {hotel?.show_hotel_info_to_customer && <div>
              {bookingOverviewTabs()}
            </div>}
            {!hotel?.show_hotel_info_to_customer && <div>
              {bookingOverviewSection()}
            </div>}
          </div>
        </div>}
      </div >
      <Modal size="lg" show={!!placeHtmlDataForShow} onHide={() => setPlaceHtmlDataForShow(null)} centered>
        <Modal.Body className="booking-policy">
          <div className="booking-term-condition" dangerouslySetInnerHTML={{ __html: placeHtmlDataForShow }} />
        </Modal.Body>
      </Modal>
      <OnceFooter />
    </>
  );
}
